import { createEl } from "./utils";

export const modalMsgs = {
  confirmPhone(phone) {
    return `
      <div class="text-center">
        <p>Confirma que el n&uacute;mero de celular que ingresaste es el correcto.</p>
        <p><strong>${phone}</strong></p>
      </div>
    `;
  },
  successRegistration(date = "09-02-2023", folio = "123456") {
    return `
      <div class="text-center">
        <p>Haz realizado correctamente tu registro, podr&aacute;s recoger tu regalo en la sucursal seleccionada a partir del ${date} presentando el siguiente folio:</p>
        <p><strong>${folio}</strong></p>
        <p>Recuerda que tienes 30 d&iacute;as naturales para recoger tu regalo.</p>
      </div>
    `;
  },
  invalidAccount() {
    return `
      <div class="text-center">
        <p>El n&uacute;mero de cuenta ingresado no cumple con las condiciones de la promoci&oacute;n.</p>
        <p><strong>Recuerda, por cada $1,000 MXN que incrementes y mantengas en tu cuenta 15 d&iacute;as naturales, te regalamos un juego de vasos.</strong></p>
        <p>Consulta t&eacute;rminos y condiciones de la promoci&oacute;n en <a href="www.bancoazteca.com.mx" target="_blank">www.bancoazteca.com.mx</a></p>
      </div>
    `;
  },
  outOfStock() {
    return `
      <div class="text-center">
        <p>Debido al &eacute;xito de la promoci&oacute;n, se agotaron las existencias establecidas.</p>
        <p>Te invitamos a participar en las siguientes promociones de Banco Azteca.</p>
      </div>
    `;
  },
  alreadyRegistered() {
    return `
      <div class="text-center">
        <p>El n&uacute;mero de cuenta ingresado ya fue registrado.</p>
        <p>Consulta t&eacute;rminos y condiciones de la promoci&oacute;n en <a href="www.bancoazteca.com.mx" target="_blank">www.bancoazteca.com.mx</a></p>
      </div>
    `;
  },
  accountBlocked() {
    return `
    <div class="text-center">
      <p>El n&uacute;mero de tu cuenta ingresado se encuentra bloqueado, te sugerimos acudir a tu sucursal m&aacute;s cercana.</p>
      <p>Consulta t&eacute;rminos y condiciones de la promoci&oacute;n en <a href="www.bancoazteca.com.mx" target="_blank">www.bancoazteca.com.mx</a></p>
    </div>
    `;
  },
  endOfPromo() {
    return `
    <div class="text-center">
      <p>Venci&oacute; el tiempo de registro (15 d&iacute;as a partir de la notificaci&oacute;n de que fuiste ganador).</p>
      <p>Te invitamos a seguir participando. Consulta t&eacute;rminos y condiciones de la promoci&oacute;n en <a href="www.bancoazteca.com.mx" target="_blank">www.bancoazteca.com.mx</a></p>
    </div>
    `;
  },
  error() {
    return `
    <div class="text-center">
      <p>Ocurri&oacute; un error, intente m&aacute;s tarde.</p>
    </div>
    `;
  }
};

/**
 * Close modal.
 * @param {any} context
 */
function closeModal(context) {
  const { overlay, modal, closeBtn } = context.modal;

  closeBtn.parentElement.removeChild(closeBtn);
  modal.parentElement.removeChild(modal);
  overlay.parentElement.removeChild(overlay);

  context.modal = undefined;
}

/**
 * Open modal
 * @param {any} content
 * @param {any} context
 */
function openModal(content, context: any = document.body) {
  const overlay = createEl("div.modal-overlay");
  const modal = createEl("div.modal-content");
  const closeBtn = createEl("div.modal-close-btn");

  if ((context as any).modal) {
    closeModal(context);
  }

  closeBtn.innerText = "X";

  overlay.appendChild(modal);
  modal.appendChild(closeBtn);
  modal.appendChild(content);

  context.appendChild(overlay);
  (context as any).modal = { overlay, modal, closeBtn };

  closeBtn.addEventListener("click", (e) => closeModal(context));
}

export function openGenericModal(message) {
  const modal = createEl("div");
  modal.innerHTML = message;
  openModal(modal, document.body);
  return modal;
}

export function openConfirmModal(message, label = "Aceptar") {
  const modal = openGenericModal(message);
  const button = createEl("button.primary-button");
  const buttonsWrapper = createEl("div.buttons");

  modal.append(buttonsWrapper);
  buttonsWrapper.append(button);
  button.innerText = label;
  button.addEventListener("click", (e) => {
    e.preventDefault();
    closeModal(document.body);
  });
}

export function openChoiseModal(message, label = "Confirmar", callback) {
  const modal = openGenericModal(message);
  const button = createEl("button.primary-button");
  const secondButton = createEl("button.secondary-button");
  const buttonsWrapper = createEl("div.buttons");

  modal.append(buttonsWrapper);
  buttonsWrapper.append(secondButton, button);
  button.innerText = label;
  button.addEventListener("click", (e) => {
    e.preventDefault();
    closeModal(document.body);
    typeof callback !== "undefined" && callback();
  });
  secondButton.innerText = "Cancelar";
  secondButton.addEventListener("click", (e) => {
    e.preventDefault();
    closeModal(document.body);
  });
}
